import * as React from 'react';
import classnames from 'classnames';

import { expandDataProps } from 'utils/helper/common';

import './cross-button.scss';

import type { Data } from 'types';

type Props = {
  type?: 'corner' | 'corner-small' | 'corner-closer',
  data?: Data,
  onClick?: (a: React.SyntheticEvent<HTMLElement>) => void
};

class CrossButton extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { type, data, onClick, ...buttonProps } = this.props;

    const buttonClasses = classnames({
      'cross-button': true,
      [`cross-button--type-${String(type)}`]: type
    });

    return (
      <button
        type="button"
        {...buttonProps}
        {...expandDataProps(data)}
        className={buttonClasses}
        onClick={onClick}
      />
    );
  }
}

export default CrossButton;
